import { forwardRef } from "react";
import { clsx } from "clsx";
import type { SelectProps } from "./SelectProps";
import classes from "./Select.module.scss";
import { ChevronDown } from "@/components/ui/Icon/ChevronDown";
import { useFormControl } from "@/hooks/useFormControl";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select(props, ref) {
    const {
      children,
      className,
      size = "medium",
      hasError,
      id,
      ...htmlProps
    } = props;

    const formControl = useFormControl();
    const selectId = id ?? formControl?.id;
    const selectHasError = hasError ?? formControl?.hasError ?? false;

    return (
      <div className={clsx(classes.wrapper, className)}>
        <select
          {...htmlProps}
          id={selectId}
          className={clsx(classes.select, classes[size], {
            [classes.valid]: !selectHasError && formControl?.isValid,
          })}
          {...(selectHasError && { "aria-invalid": true })}
          ref={ref}
        >
          {children}
        </select>

        <div className={classes.icon}>
          <ChevronDown size={24} color="currentColor" />
        </div>
      </div>
    );
  },
);
